/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */

import React from 'react';

export const RovoGeneratingAnimation = (): React.JSX.Element => {
	return (
		<svg
			width="14"
			height="20"
			viewBox="0 0 14 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden={true}
		>
			<circle cx="3" cy="14" r="1" fill={'#1F69DA'}>
				<animate
					attributeName="opacity"
					values="0;1;1;1;"
					dur="0.8s"
					repeatCount="indefinite"
					begin="0s"
				/>
			</circle>
			<circle cx="7" cy="14" r="1" fill={'#C16CD4'}>
				<animate
					attributeName="opacity"
					values="0;0;1;1;"
					dur="0.8s"
					repeatCount="indefinite"
					begin="0s"
				/>
			</circle>
			<circle cx="11" cy="14" r="1" fill={'#F5A117'}>
				<animate
					attributeName="opacity"
					values="0;0;0;1;"
					dur="0.8s"
					repeatCount="indefinite"
					begin="0s"
				/>
			</circle>
		</svg>
	);
};
